import { Power3, gsap } from 'gsap';

import { Sizes } from '../_app/cuchillo/core/Sizes';
import _Footer from '../_app/cuchillo/layout/Footer';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Footer extends _Footer {
    static isFixed = false;
    static KoraBtnTop;
    static koraBtnBottom;
    static footerBottom;
    static isSmartphone =
        window.innerWidth <= Sizes.SMARTPHONE ||
        window.innerHeight <= Sizes.SMARTPHONE;
    static footerTop;

    //static show(__call) {}
    //static hide(__call) {}

    static init() {
        super.init();
        this.KoraBtnTop = GetBy.id('top__title');
        this.koraBtnBottom = GetBy.id('bottom__title');
        this.footerTop = GetBy.selector('footer .top');
        this.footerBottom = GetBy.selector('footer .bottom');
        if (this.isSmartphone) {
            this.footerTop[0].style.height = '0px';
            this.footerBottom[0].style.height = '0px';
        }

        console.log('Footer.init', this.footerBottom);
        this.showFooter();
    }

    static showFooter() {
        this.KoraBtnTop.addEventListener('click', () => {
            console.log('Kora button clicked');
            const top = this.footerTop[0];

            if (top.classList.contains('active')) {
                this.KoraBtnTop.classList.remove('active');
                top.classList.remove('active');
                gsap.to(top, {
                    duration: 0.6,
                    ease: Power3.easeOut,
                    height: 0,
                    onComplete: () => {
                        top.style.overflow = '';
                    }
                });
            } else {
                this.KoraBtnTop.classList.add('active');
                top.classList.add('active');
                gsap.set(top, { overflow: 'hidden' });

                const fullHeight = top.scrollHeight;

                gsap.to(top, {
                    duration: 0.6,
                    ease: Power3.easeOut,
                    height: fullHeight + 'px',
                    onComplete: () => {
                        top.style.height = 'auto';
                    }
                });
            }
        });
        this.koraBtnBottom.addEventListener('click', () => {
            console.log('Kora button clicked');
            const bottom = this.footerBottom[0];

            if (bottom.classList.contains('active')) {
                this.koraBtnBottom.classList.remove('active');
                bottom.classList.remove('active');
                gsap.to(bottom, {
                    duration: 0.6,
                    ease: Power3.easeOut,
                    height: 0,
                    onComplete: () => {
                        bottom.style.overflow = '';
                    }
                });
            } else {
                this.koraBtnBottom.classList.add('active');
                bottom.classList.add('active');
                gsap.set(bottom, { overflow: 'hidden' });

                const fullHeight = bottom.scrollHeight;

                gsap.to(bottom, {
                    duration: 0.6,
                    ease: Power3.easeOut,
                    height: fullHeight + 'px',
                    onComplete: () => {
                        bottom.style.height = 'auto';
                    }
                });
            }
        });
    }
}
